import { render, staticRenderFns } from "./ProjectsModalOverviewComplete.vue?vue&type=template&id=3d2dfd5b&"
import script from "./ProjectsModalOverviewComplete.vue?vue&type=script&lang=js&"
export * from "./ProjectsModalOverviewComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2dfd5b')) {
      api.createRecord('3d2dfd5b', component.options)
    } else {
      api.reload('3d2dfd5b', component.options)
    }
    module.hot.accept("./ProjectsModalOverviewComplete.vue?vue&type=template&id=3d2dfd5b&", function () {
      api.rerender('3d2dfd5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/projects/ProjectsModalOverviewComplete.vue"
export default component.exports